import Group3Fill from '@/assets/icons/group_3_fill.svg?component';
import ListCheck from '@/assets/icons/list_check.svg?component';
import Search2Fill from '@/assets/icons/search_2_fill.svg?component';
import Share2Line from '@/assets/icons/share_2_line.svg?component';
import Transfer4Fill from '@/assets/icons/transfer_4_fill.svg?component';

import type { SidebarLevelConfig } from './types';

/** Internal (admin) level. */
export const internalLevel: SidebarLevelConfig = {
    level: 'internal',
    matchPattern: '/internal',
    // No back button — internal is a top-level view
    items: [
        {
            id: 'internal-bioscopes',
            label: 'sidebarItems.internal.bioscopes',
            analyticsLabel: 'Bioscopes',
            path: '/bioscopes',
            icon: Transfer4Fill,
            exact: true,
        },
        {
            id: 'internal-cages',
            label: 'sidebarItems.internal.cages',
            analyticsLabel: 'Cages',
            path: '/cages',
            icon: Transfer4Fill,
            exact: true,
        },
        {
            id: 'internal-clients',
            label: 'sidebarItems.internal.clients',
            analyticsLabel: 'Clients',
            path: '/clients',
            icon: Search2Fill,
            exact: false,
        },
        {
            id: 'internal-users',
            label: 'sidebarItems.shared.users',
            analyticsLabel: 'Users',
            path: '/users',
            icon: Group3Fill,
            exact: true,
        },
        {
            id: 'internal-audit-log',
            label: 'auditLog.nav',
            path: '/audit-log',
            icon: ListCheck,
            exact: true,
            visibility: { requiresAuditLogAccess: true },
        },
        {
            id: 'internal-data-shares',
            label: 'sidebarItems.internal.dataShares',
            analyticsLabel: 'Data shares',
            path: '/data-shares',
            icon: Share2Line,
            exact: true,
            visibility: { requiredFeatureFlags: ['provider-config-ui'] },
        },
    ],
};
